import axiosInstance from '@/services/axiosInstance'

async function getBrandShare (groupId, categoryId, siteId, startDate, endDate, data) {
  const req = {
    url: `brandshare/${groupId}/${categoryId}/${siteId}/${startDate}/${endDate}`,
    method: 'POST',
    data
  }

  const res = await axiosInstance(req)

  return res.data
}

export { getBrandShare }
